<div class="p-(--padding-card)">
  <ces-route-title [count]="roleStore.entities().length">
    <div class="flex items-center gap-(--gap-normal)">
      <ces-button-secondary
        variant="secondary"
        [label]="'common.buttons.cancel' | transloco"
        [disabled]="pendingChangeCount === 0 || saving"
        (onClick)="cancelChanges()" />
      <ces-button
        [label]="'common.buttons.save' | transloco"
        icon="save"
        [disabled]="pendingChangeCount === 0 || saving"
        (onClick)="saveChanges()" />
      <ces-button [label]="roleDefinition.messages.buttons.create() | transloco" icon="add" (onClick)="addRole()" />
    </div>
  </ces-route-title>
</div>

<div class="flex flex-col gap-(--gap-normal)">
  @if (loadFailed) {
    <div class="flex flex-col items-center gap-(--gap-normal) py-16 text-(--text-secondary)">
      <ces-icon size="xl" containerSize="md">error</ces-icon>
      <p>{{ 'common.errors.dataLoadFailed' | transloco }}</p>
      <ces-button [label]="'pages.errors.500.retry' | transloco" icon="refresh" (onClick)="loadData()" />
    </div>
  } @else if (!dataLoadingCompleted) {
    <div class="flex flex-col gap-(--space-2) px-(--padding-card)" aria-busy="true">
      @for (row of skeletonRows; track row) {
        <div class="h-10 rounded-md bg-(--surface-2) animate-pulse"></div>
      }
    </div>
  } @else if (roles.length === 0) {
    <div class="flex flex-col items-center gap-(--gap-normal) py-16 text-(--text-secondary)">
      <ces-icon size="xl" containerSize="md">admin_panel_settings</ces-icon>
      <p>{{ 'entities.role.matrix.empty' | transloco }}</p>
      <ces-button [label]="roleDefinition.messages.buttons.create() | transloco" icon="add" (onClick)="addRole()" />
    </div>
  } @else {
    @if (pendingChangeCount > 0 || roles.length > roleFilterThreshold) {
      <div class="flex items-center justify-between px-(--padding-card)">
        <span class="text-sm text-(--text-secondary)">
          @if (pendingChangeCount > 0) {
            {{ 'entities.role.matrix.unsavedCount' | transloco: { count: pendingChangeCount } }}
          }
        </span>
        @if (roles.length > roleFilterThreshold) {
          <input
            type="text"
            class="perm-role-filter"
            [(ngModel)]="roleFilter"
            [placeholder]="'entities.role.matrix.filterPlaceholder' | transloco"
            [attr.aria-label]="'entities.role.matrix.filterPlaceholder' | transloco" />
        }
      </div>
    }

    <p-table [value]="matrixRows" [scrollable]="true">
      <ng-template #header>
        <tr>
          <th class="min-w-[220px]" [cesFrozenColumn]="true">{{ 'entities.role.matrix.permissionColumn' | transloco }}</th>
          @for (role of visibleRoles; track role.id) {
            <th class="min-w-[180px]">
              <div class="flex items-center gap-(--gap-normal)">
                <ces-button-secondary
                  variant="secondary"
                  size="small"
                  icon="settings"
                  [tooltip]="'common.buttons.edit' | transloco"
                  [ariaLabel]="('common.buttons.edit' | transloco) + ' ' + role.name"
                  tooltipPosition="bottom"
                  (onClick)="onEditRole(role)" />
                <span class="truncate max-w-[140px]" [pTooltip]="role.name" tooltipPosition="bottom">{{ role.name }}</span>
              </div>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template #body let-row>
        @if (row.kind === 'group') {
          <tr class="perm-group-row">
            <td [cesFrozenColumn]="true" class="uppercase text-xs font-semibold tracking-wider text-(--text-secondary)">
              {{ row.labelKey | transloco }}
            </td>
            <td [attr.colspan]="visibleRoles.length"></td>
          </tr>
        } @else {
          <tr>
            <td [cesFrozenColumn]="true">{{ getPermissionName(row.permission) }}</td>
            @for (role of visibleRoles; track role.id) {
              <td>
                <div class="inline-flex" [class.perm-dirty]="isDirty(role.id, row.permission.id)">
                  <p-select
                    [options]="options"
                    [ngModel]="getPermissionType(role.id, row.permission.id)"
                    (ngModelChange)="onPermissionChange(role, row.permission, $event)"
                    optionLabel="label"
                    [disabled]="saving"
                    [ariaLabel]="cellAriaLabel(role, row.permission)"
                    styleClass="w-auto min-w-[140px] rounded-full bg-(--surface-2) focus-within:outline-none focus-within:shadow-none focus-within:border-none"
                    appendTo="body">
                    <ng-template let-option pTemplate="item">
                      <div class="flex items-center gap-(--gap-normal)">
                        <span
                          class="inline-block w-[10px] h-[10px] rounded-full mr-(--space-2)"
                          [style.background-color]="getColor(option.value)"></span>
                        <span>{{ option.label }}</span>
                      </div>
                    </ng-template>
                    <ng-template let-selected pTemplate="selectedItem">
                      <div class="select-item">
                        <span
                          class="inline-block w-[10px] h-[10px] rounded-full mr-(--space-2)"
                          [style.background-color]="getColor(selected.value)"></span>
                        <span>{{ selected.label }}</span>
                      </div>
                    </ng-template>
                  </p-select>
                </div>
              </td>
            }
          </tr>
        }
      </ng-template>
    </p-table>
  }
</div>
